export const ListWrapper = (item, colList) => {
  const listData = colList.map((cols) => {
    return item[cols.key];
  });
  return listData;
};

export const dataBinder = (filterListUpdate, data, filterType) => {
  let tempFilterList = [...filterListUpdate];
  tempFilterList.map((row) => {
    switch (row.filterValue) {
      case "":
        return (row.count = data.details.total);
      case "ACTIVE":
        if (filterType === "CSR") {
          return (row.count = data.details.active);
        } else if (filterType === "USERLIST") {
          return (row.count = data.details.totalActive);
        }
        break;
      case "FALSE":
        return (row.count = data.details.totalInactive);
      case "TRUE":
        return (row.count = data.details.totalActive);
      case "CANCEL":
        return (row.count = data.details.cancel);
      case "NOTICE":
        return (row.count = data.details.notice);
      case "INACTIVE":
        return (row.count = data.details.totalInactive);
      case "OPEN":
        return (row.count = data.details.open);
      case "CLOSED":
        return (row.count = data.details.closed);
      case "RECORD ONLY":
        return (row.count = data.details.recordOnly);
      case "SALVAGE PENDING":
        return (row.count = data.details.salvagePending);
      case "SUBRO PENDING":
        return (row.count = data.details.subroPending);
      case "RENEWALPOLICY":
        return (row.count = data.details.renewalPolicy);
      case "NEWPOLICY":
        return (row.count = data.details.newPolicy);
      case "PREMIUM":
        return (row.count = data.details.premium);
      case "NONPREMIUM":
        return (row.count = data.details.nonPremium);
      case "ALL":
        if (filterType === "USERLIST") {
          return (row.count = data.details.totalUser);
        } else {
          return (row.count = data.details.totalCount);
        }
      case true:
        return (row.count = data.details.clearByCount);
      case false:
        return (row.count =
          data.details.totalCount - data.details.clearByCount);

      default:
        break;
    }
    return row;
  });
  return tempFilterList;
};

export const dataWrapper = (vehicalDetails = [], driverDetails = []) => {
  let vinInfo = [];
  vehicalDetails.forEach((vehicle, parentIndex) => {
    driverDetails.forEach((driver, childIndex) => {
      if (parentIndex === childIndex) {
        vinInfo.push({
          vehicleInfo: vehicle,
          driverInfo: driver,
        });
      }
    });
  });
  return vinInfo;
};
